export const fetchEditProfile = async (sessionId: string, email: string, phone: string, password: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'set_user_info');
		formData.append('email', email.trim());
		formData.append('sms', phone.trim());
		formData.append('user_password', password.trim());
		formData.append('session_id', sessionId);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
